import { Status } from '@app/misc/Status';
import { useConfigurationContext } from '@app/root/ConfigurationContext';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import { MemberLight, MemberSummary, updateMemberStatus } from '@wwf/sdk';
import { useRecordContext, useRefresh } from 'react-admin';

export const MemberStatusEditor = () => {
    const record = useRecordContext<MemberSummary | MemberLight>();
    const { memberStatusLabels } = useConfigurationContext();
    const refresh = useRefresh();

    if (!record || !memberStatusLabels) return null;

    const handleStatusChange = (event: any) => {
        const newStatus = event.target.value || null;
        updateMemberStatus(record.id, { status: newStatus });
        refresh();
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel>Status</InputLabel>
            <Select
                value={record.status || ''}
                onChange={handleStatusChange}
                label="Status"
            >
                <MenuItem value="">
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box width={10} height={10} />
                        <em>No status</em>
                    </Box>
                </MenuItem>
                {memberStatusLabels.map(status => (
                    <MenuItem key={status.value} value={status.value}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Status status={status.value} />
                            {status.label}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
